export default __webpack_public_path__ + "2b3e1faf89f94a4835397e7a43b4f77d.png";